import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import { RateHistoryInterface } from '../../store/callrecorder/rateHistoriesSlice';

const PREFIX = 'callrecorder';

export const rateHistoriesEntity = new schema.Entity('rate_histories');

const fetchRateHistoriesCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params });
  const normalized = normalize<
    any,
    { rate_histories: { [key: string]: RateHistoryInterface } }
  >(response.data.rate_histories, [rateHistoriesEntity]);

  return {
    rateHistories: normalized.entities?.rate_histories || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchRateHistories = createAsyncThunk(
  `${PREFIX}_rate_histories/fetchRateHistories`,
  async (params: object = {}) => fetchRateHistoriesCollection('/onesky/rate_histories', params)
);
